"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("Modals/ModalComponent/Modal"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class RegistrationModal extends _react.Component {
  state = {
    loading: false,
    created: false,
    ready: false,
    status_messages: {}
  };
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.open === true && !props.open) {
      component.handleClose();
    }
  }
  handleClose = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      created: false,
      ready: false
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['black', 'bg-white']
    }) : undefined;
    const status = (0, _getFormStatus.default)(state);
    const content = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-text-center u-margin-top-20 u-margin-bottom-20"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-toggle__txt"
    }, "Vous \xEAtes")), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-text-center u-margin-top-20"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--medium u-margin-right-10",
      href: (0, _Routes.URL)('NewCandidateFront', _Routes.front_urls)
    }, "Un candidat"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--medium u-margin-left-10",
      href: (0, _Routes.URL)('NewCompanyFront', _Routes.front_urls)
    }, "Une entreprise")));
    const output = /*#__PURE__*/_react.default.createElement(_Modal.default, {
      open: props.open || false,
      onClose: props.onClose,
      title: "Inscription",
      scroll_area: props.scroll_area || '.front-page',
      bemit: ['small', 'simple'],
      src: props.trigger_src,
      close_label: state.created ? 'Fermer' : 'Annuler',
      close_classes: "c-btn c-btn--small c-btn--black"
    }, content, props.children, status, loader);
    return output;
  }
}
exports.default = RegistrationModal;
